import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { Helmet } from "react-helmet-async";
import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from "../../Components/MastheadAnnouncement";

import Endpoint from "../../Components/Endpoint";
import sampleEndpts from "../../json/sampleEndpts.json";

import map from "../../images/bfa_map_v5.png";
import journeys from "../../images/bfa_journeys.png";

const BfaServices = () => {
  const location = useLocation();

  const endpointreturnRouteWalk = (id) => {
    const endpt_elem = {
      page_section: "routeWalk",
      method: "GET",
      endpoint: "/api/public/routingsvc/route",
      sampleRequest:
        "/api/public/routingsvc/route?start=1.319728%2C103.8421&end=1.319728905%2C103.8421581&routeType=walk",
      sampleResponse:
        '{\n  "status_message": "Found route between points",\n  "route_geometry": "{u`GktxxR?G",\n  "status": 0,\n  "route_instructions": [\n    [\n      "Left",\n      "",\n      5,\n      "1.319498,103.842142",\n      3,\n      "5m",\n      "East",\n      "North",\n      "walking",\n      "Head East"\n    ],\n    [\n      "Left",\n      "",\n      0,\n      "1.319502,103.842179",\n      0,\n      "0m",\n      "North",\n      "East",\n      "walking",\n      "You Have Arrived At Your Destination, On The Left"\n    ]\n  ],\n  "route_name": [\n    ""\n  ],\n  "route_summary": {\n    "start_point": "",\n    "end_point": "",\n    "total_time": 3,\n    "total_distance": 5\n  }\n}',
    };

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sample,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const endpointreturnBfa = (id) => {
    const endpt_elem = sampleEndpts.find((e) => e.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <Helmet>
        <title>BFA API: Barrier Free Access | OneMap API</title>
        <meta
          name="description"
          content="Explore OneMap's Barrier Free Access (BFA) API for Singapore, offering real-time information on accessible routes and facilities. Easily plan your journey with detailed accessibility data."
        />
      </Helmet>
      <MastheadAnnouncement />
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div id="om-routing-section" className="om-routing-section">
              <h1 id="routing">SLA Barrier-Free Access (BFA) Routing</h1>
              <div className="om-routing-intro">
                <p>
                  Developed by the Singapore Land Authority (SLA), Barrier-Free
                  Access (BFA) Routing provides wheelchair-friendly routes that
                  have been tested and verified by wheelchair users. These
                  routes guide users to safe, accessible paths, as not all
                  routes accommodate wheelchair users.
                </p>
              </div>
              <br />
              <h3>What Does BFA Routing Do?</h3>
              <div className="om-routing-intro">
                <p>
                  BFA Routing highlight routes that are more suitable for
                  wheelchair users by avoiding common physical barriers such as
                  stairs, steep gradients, and inaccessible walkways. By
                  reducing uncertainty, it supports safer, more independent
                  movement through the city.
                </p>
              </div>
              <br />
              <h3>Where Is It Available?</h3>
              <div className="om-routing-intro">
                <p>
                  BFA routing is currently available in selected areas across
                  Singapore, including:
                </p>
                <p>
                  Ang Mo Kio, Bedok, Bukit Merah, Chong Pang, Downtown Core,
                  Kallang, Marina South, Museum, NUS Campus, Orchard, Outram,
                  Punggol, Singapore River, Tampines, Tanglin, West Coast,
                  Clementi, Queenstown and Toa Payoh.
                </p>
                <p>
                  Hougang, Sengkang and Sembawang are the next upcoming areas.
                </p>
                <p>
                  Coverage will continue to expand as more routes are tested and
                  verified.
                </p>

                <div className="map row justify-content-center">
                  <div className="col-12">
                    <img
                      alt="BFA Coverage Map"
                      src={map}
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <h3>How we can use Barrier-Free Routing:</h3>
              <div className="om-routing-intro">
                <div className="map row justify-content-center">
                  <div className="col-12">
                    <img
                      src={journeys}
                      alt="BFA Journeys"
                      style={{ width: "100%", height: "auto", display: "block" }}
                    />
                  </div>
                </div>
                <br />
                <p>
                  Accessibility is not one-size-fits-all. SLA's Barrier-Free
                  Access Routing transform lived experience into shared
                  knowledge, making movement through Singapore more predictable,
                  empowering, and inclusive. Each verified route brings us
                  closer to a city where everyone can navigate with dignity and
                  confidence.
                </p>
                <p>
                  The Barrier-Free Access API is currently only available by
                  request to approved users. For any enquiries, please write to:
                  &nbsp;
                  <a
                    href="https://go.gov.sg/bfa-enquires"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://go.gov.sg/bfa-enquiries
                  </a>
                </p>
              </div>

              <br />
              <h1>BFA API</h1>
              <div className="om-routing-intro">
                <p>
                  This endpoint finds optimal routes between two geographic
                  coordinates, with support for barrier-free access (BFA)
                  routing for accessibility needs.
                </p>
              </div>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>400 - Starting location is required. </p>
                <p>400 - Destination location is required.</p>
                <p>400 - Both start and destination locations are required.</p>
                <p>400 - Latitude and longitude must be provided.</p>
                <p>401 - Unauthorized</p>
                <p>
                  403 - User is not authorized to access this resource with an
                  explicit deny in an identity-based policy
                </p>
                <p>404 - No BFA route found between the specified locations</p>
                <p>404 - Start location is outside BFA coverage area</p>
                <p>404 - Destination is outside BFA coverage area</p>
                <p>
                  404 - Both start location and destination are outside BFA
                  coverage area
                </p>
                <p>429 - Exceeded quota limit</p>
              </div>
              <br />
              <div className="om-cc-wrapper">
                <div className="om-cc">
                  <h4 className="om-cc-header">HEADER PARAMETERS</h4>
                </div>
                <div className="om-cc-items">
                  <div className="om-cc-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-cc-wrapper">
                <div className="om-cc">
                  <h4 className="om-cc-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-cc-items">
                  <div className="om-cc-item">
                    <div className="label-method">
                      start
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-cc-desc">
                      <p>
                        The start point in WGS84 latitude, longitude format.
                      </p>
                    </div>
                  </div>
                  <div className="om-cc-item">
                    <div className="label-method">
                      end
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-cc-desc">
                      <p>The end point in WGS84 latitude, longitude format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturnBfa("bfa")} />
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default BfaServices;
